/**
 * PONER UN ENLACE O UN PDF EN EL CUERPO DE UN CORREO MASIVO.
 *
 * Lissette, 2026-09-01 (punto 6 de 9): poder adjuntar un PDF y poner un
 * enlace en el correo masivo.
 *
 * El cuerpo del correo masivo es HTML CRUDO: hasta ahora, poner un enlace
 * obligaba a escribir `<a href="...">...</a>` a mano. Esto arma el fragmento
 * por ella.
 *
 * Vive fuera del componente para poder ejecutarlo en las pruebas sin montar
 * React ni arrastrar MSAL.
 */

/**
 * El texto que ve el cliente va DENTRO de etiquetas, asi que hay que
 * escaparlo: un fichero llamado "Planes 2027 & 2028.pdf" romperia el HTML del
 * correo por la mitad, y un texto con "<" abriria una etiqueta.
 */
export function escaparHtml(t) {
  return String(t ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}

/**
 * La direccion con esquema. Sin el, el navegador del cliente lee
 * "deskte.com/agenda" como una ruta RELATIVA de su propio correo web
 * —mail.google.com/deskte.com/agenda— y el enlace no lleva a ninguna parte.
 * Es el fallo mas facil de cometer escribiendo una direccion a mano.
 */
export function conEsquema(url) {
  const u = String(url || '').trim();
  if (!u) return '';
  if (/^(?:https?:|mailto:|tel:)/i.test(u)) return u;
  return `https://${u}`;
}

/** El `<a>` listo para pegar. Sin texto, se ve la propia direccion. */
export function enlaceHtml(url, texto) {
  const destino = conEsquema(url);
  if (!destino) return '';
  const visible = String(texto || '').trim() || destino;
  return `<a href="${escaparHtml(destino)}">${escaparHtml(visible)}</a>`;
}

/**
 * El PDF se enseña como BOTON, no como una direccion suelta: el cliente lee
 * "Descargar Planes 2027" en vez de una URL larga con un identificador
 * aleatorio dentro, que parece un enlace sospechoso y nadie pulsa.
 *
 * Los estilos van EN LINEA porque los correos no cargan hojas de estilo.
 */
export function botonDePdfHtml(url, nombre, lang = 'es') {
  const destino = conEsquema(url);
  if (!destino) return '';
  const etiqueta = lang === 'es' ? 'Descargar' : 'Download';
  return `<p><a href="${escaparHtml(destino)}" style="display:inline-block;`
    + `background:#0a66c2;color:#ffffff;text-decoration:none;padding:10px 18px;`
    + `border-radius:8px;font-weight:700">📄 ${etiqueta} ${escaparHtml(nombre)}</a></p>`;
}
